"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityBrokingSlipActivityDocumentMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_activity_map_entity_1 = require("./opportunity-activity-map.entity");
const file_upload_entity_1 = require("./file-upload.entity");
const opportunity_entity_1 = require("./opportunity.entity");
let OpportunityBrokingSlipActivityDocumentMap = class OpportunityBrokingSlipActivityDocumentMap {
};
exports.OpportunityBrokingSlipActivityDocumentMap = OpportunityBrokingSlipActivityDocumentMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityBrokingSlipActivityDocumentMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_map_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityBrokingSlipActivityDocumentMap.prototype, "opportunityActivityMapId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityBrokingSlipActivityDocumentMap.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityBrokingSlipActivityDocumentMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_type_lid", type: "int", nullable: false }) // Add the new column
    ,
    tslib_1.__metadata("design:type", Number)
], OpportunityBrokingSlipActivityDocumentMap.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_activity_map_entity_1.OpportunityActivityMap, (activityMap) => activityMap.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_activity_map_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityBrokingSlipActivityDocumentMap.prototype, "opportunityActivityMap", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityBrokingSlipActivityDocumentMap.prototype, "opportuniryDetail", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload, (fileUpload) => fileUpload.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "document_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityBrokingSlipActivityDocumentMap.prototype, "document", void 0);
exports.OpportunityBrokingSlipActivityDocumentMap = OpportunityBrokingSlipActivityDocumentMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_broking_slip_activity_document_map")
], OpportunityBrokingSlipActivityDocumentMap);
